import { Settings } from 'lucide-react';

import { Widget, WidgetBody, WidgetTitle } from '@@/Widget';

import { useAdditionalFunctionalitySettings } from '../../queries/useAdditionalFunctionalitySettings';

import { AdditionalFunctionalityForm } from './AdditionalFunctionalityForm';

export function AdditionalFunctionality() {
  const settingsQuery = useAdditionalFunctionalitySettings();

  if (!settingsQuery.data) {
    return null;
  }

  const settings = settingsQuery.data;

  return (
    <Widget id="additional-functionality">
      <WidgetTitle icon={Settings} title="Additional functionality" />
      <WidgetBody>
        <AdditionalFunctionalityForm
          settings={settings.additionalFunctionality}
        />
      </WidgetBody>
    </Widget>
  );
}
